import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { InterstateThemeProvider } from '@interstate/components/InterstateThemeProvider';
import { interstateThemeRegistry } from '@interstate/components/InterstateTheming/themes/interstateThemeRegistry';
import { TestAnalyticsTracker } from '@interstate/components/analytics';

import App from './App';
import reportWebVitals from './reportWebVitals';

const analyticsTracker = new TestAnalyticsTracker();

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <InterstateThemeProvider
      themeName="Interstate"
      themeRegistries={[interstateThemeRegistry]}
      applicationName="AMS Pairing"
      scopeName="ams-pairing"
      analyticsTracker={analyticsTracker}
    >
      <App />
    </InterstateThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
